var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fluid",attrs:{"id":"app"}},[_c('div',{attrs:{"id":"fullPage"}},[_c('LAHeader'),_c('div',{staticClass:"fluid",attrs:{"id":"main-wrapper"}},[_c('div',{staticClass:"container master-container"},[_c('router-view')],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }